import { makeStyles } from "@material-ui/core";
import PageHead from "../pageheading/pageheading";
import SingleCheckoutPageContent from "./SingleCheckoutPageContent";
const useStyles = makeStyles((theme) => ({
  containerfluid: {
    width: '100%',
    fontFamily: "'Jost', sans-serif",
    marginBottom:'13rem',
    [theme.breakpoints.down("xs")]: {
    marginBottom:'13rem',
    },
  },
}));
function SingleCheckoutPage() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      headingsmall:
        "Explore Privacy Policy",
      headingmain: "Checkout",
      breadcrumb:"Checkout"
    },
  ];
  
  return (
    <div className={classes.containerfluid}>
      <PageHead Heading={Heading}/>
      <SingleCheckoutPageContent />
    </div>
  );
}

export default SingleCheckoutPage;
